import { useLang } from 'hooks/lang';

import { Tag, TagProps } from 'components/Blocks';

import { cn } from 'styles';

interface ServiceOutsourcedTagProps extends Partial<Omit<TagProps, 'name'>> {
  children?: never;
}

export function ServiceOutsourcedTag({ className, ...props }: ServiceOutsourcedTagProps) {
  const { t } = useLang();

  return (
    <Tag
      name={t('outsourced')}
      color="foreground"
      className={cn('text-background', className)}
      {...props}
    />
  );
}
